import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import classnames from "classnames";
import { useBlobUrl, useIsDesktop } from "../../hooks/index.js";
import { Button } from "../../Button/index.js";
import { Icon } from "../../Icon/index.js";
import { PreviewButtons } from "./Buttons/index.js";
import { useStyles } from "./Preview.styles.js";
const PreviewImage = (t0)=>{
    const $ = c(37);
    const { url, shape, clickable, onClickDownload, withCollapsableFooter, centerImage, onLoadSuccess, onExpand, onLoadFull, height, width, maxHeight, maxWidth } = t0;
    let t1;
    if ($[0] !== height || $[1] !== maxHeight || $[2] !== maxWidth || $[3] !== width) {
        t1 = {
            height,
            width,
            maxHeight,
            maxWidth
        };
        $[0] = height;
        $[1] = maxHeight;
        $[2] = maxWidth;
        $[3] = width;
        $[4] = t1;
    } else t1 = $[4];
    const { classes } = useStyles(t1);
    const isDesktop = useIsDesktop();
    const { createUrl } = useBlobUrl();
    let t2;
    if ($[5] !== onLoadSuccess) {
        t2 = ()=>{
            if (onLoadSuccess) onLoadSuccess();
        };
        $[5] = onLoadSuccess;
        $[6] = t2;
    } else t2 = $[6];
    const handleImageLoad = t2;
    const t3 = "square" === shape && classes.image_square;
    let t4;
    if ($[7] !== classes.image || $[8] !== t3) {
        t4 = classnames(classes.image, t3);
        $[7] = classes.image;
        $[8] = t3;
        $[9] = t4;
    } else t4 = $[9];
    const imageClasses = t4;
    const t5 = centerImage && classes.centerImage;
    let t6;
    if ($[10] !== classes.collapseWrapper || $[11] !== classes.root || $[12] !== t5) {
        t6 = classnames(classes.root, classes.collapseWrapper, t5, "aqa_file_preview_image");
        $[10] = classes.collapseWrapper;
        $[11] = classes.root;
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== classes.square || $[15] !== shape) {
        t7 = "square" === shape && /*#__PURE__*/ jsx("div", {
            className: classes.square
        });
        $[14] = classes.square;
        $[15] = shape;
        $[16] = t7;
    } else t7 = $[16];
    let t8;
    if ($[17] !== clickable || $[18] !== createUrl || $[19] !== handleImageLoad || $[20] !== imageClasses || $[21] !== onLoadFull || $[22] !== url) {
        t8 = clickable ? /*#__PURE__*/ jsx("a", {
            href: url,
            onClick: (e)=>{
                if (onLoadFull) {
                    e.preventDefault();
                    e.stopPropagation();
                    onLoadFull().then((blob)=>createUrl(blob)).catch(()=>url).then(_temp);
                }
            },
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/ jsx("img", {
                className: imageClasses,
                src: url,
                alt: "",
                onLoad: handleImageLoad
            })
        }) : /*#__PURE__*/ jsx("img", {
            className: imageClasses,
            src: url,
            alt: "",
            onLoad: handleImageLoad
        });
        $[17] = clickable;
        $[18] = createUrl;
        $[19] = handleImageLoad;
        $[20] = imageClasses;
        $[21] = onLoadFull;
        $[22] = url;
        $[23] = t8;
    } else t8 = $[23];
    let t9;
    if ($[24] !== onClickDownload || $[25] !== withCollapsableFooter) {
        t9 = onClickDownload && /*#__PURE__*/ jsx(PreviewButtons, {
            withCollapsableFooter: withCollapsableFooter,
            onClickDownload: onClickDownload
        });
        $[24] = onClickDownload;
        $[25] = withCollapsableFooter;
        $[26] = t9;
    } else t9 = $[26];
    let t10;
    if ($[27] !== classes.expandButton || $[28] !== isDesktop || $[29] !== onExpand) {
        t10 = onExpand && isDesktop && /*#__PURE__*/ jsx("div", {
            className: classes.expandButton,
            children: /*#__PURE__*/ jsx(Button, {
                icon: /*#__PURE__*/ jsx(Icon, {
                    name: "fullscreen_outline",
                    size: "20"
                }),
                size: "small",
                onClick: onExpand
            })
        });
        $[27] = classes.expandButton;
        $[28] = isDesktop;
        $[29] = onExpand;
        $[30] = t10;
    } else t10 = $[30];
    let t11;
    if ($[31] !== t10 || $[32] !== t6 || $[33] !== t7 || $[34] !== t8 || $[35] !== t9) {
        t11 = /*#__PURE__*/ jsxs("div", {
            className: t6,
            children: [
                t7,
                t8,
                t9,
                t10
            ]
        });
        $[31] = t10;
        $[32] = t6;
        $[33] = t7;
        $[34] = t8;
        $[35] = t9;
        $[36] = t11;
    } else t11 = $[36];
    return t11;
};
function _temp(objUrl) {
    window.open(objUrl, "_blank");
}
export { PreviewImage };
